/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { useEffect, useState } from "react"
import {
    Color,
    Column,
    Element,
    Label,
    Row,
    MomentsGrid,
    dbQueryByLambda,
    Button,
} from "trux"
import { SimpleTopBar } from "../../SimpleTopBar"
import traceBotGoal from "../../../assets/img/tracebot_goal.svg"

import "./ReferralsSuccessfulPage.css"

export const ReferralsSuccessfulPage = () => {
    let [loadingClips, setLoadingClips] = useState(false)
    let [clips, setClips] = useState([])

    useEffect(() => {
        setLoadingClips(true)
        dbQueryByLambda("webex_latest_goals_overall", { limit: 99 })
            .then((data) => {
                data.forEach((item, index) => {
                    data[index].meta = JSON.parse(data[index].meta)
                })
                setClips(data)
            })
            .catch((error) => {
                console.error("Loading clips error: ", error)
            })
            .finally(() => setLoadingClips(false))
    }, [])

    return (
        <>
            <SimpleTopBar />

            <Element className="referrals-success-content-wrapper">
                <Column
                    className="referrals-success-content"
                    justifyContent="center"
                    marginLeft="4"
                    marginTop="10"
                    marginRight="4"
                    marginBottom="8"
                >
                    <Row justifyContent="center" marginBottom="4">
                        <Element
                            className="referrals-success-trace-bot"
                            tag="img"
                            src={traceBotGoal}
                            alt="referrals-success-trace-bot"
                        />
                    </Row>
                    <Row justifyContent="center" margin="4">
                        <Label
                            className="referrals-text"
                            type={Label.Type.Heading2}
                            color={Color.Black}
                            content={`Trace will be in touch soon!`}
                        />
                    </Row>
                    <Row
                        justifyContent="center"
                        marginLeft="4"
                        marginRight="4"
                        marginBottom="2"
                    >
                        <Label
                            className="referrals-text"
                            type={Label.Type.Body}
                            color={Color.Grey1}
                            content={`I rarely tell dad jokes, but if I do he typically laughs.`}
                        />
                    </Row>
                    <Row
                        justifyContent="center"
                        marginLeft="4"
                        marginRight="4"
                        marginBottom="12"
                    >
                        <Label
                            className="referrals-text"
                            type={Label.Type.Body}
                            color={Color.Grey1}
                            content={`-TRACE_BOT`}
                        />
                    </Row>
                    <Row justifyContent="center" margin="4">
                        <Label
                            className="referrals-text"
                            type={Label.Type.Heading4}
                            color={Color.Black}
                            content={`Latest Trace Goals`}
                        />
                    </Row>
                    <Row
                        justifyContent="center"
                        marginLeft="4"
                        marginRight="4"
                        marginBottom="4"
                    >
                        <Label
                            className="referrals-text"
                            type={Label.Type.Body}
                            color={Color.Grey1}
                            content={`Check out the Trace All-in-one Game Film System in action! These goals are automatically edited by TRACE_BOT after every game.`}
                        />
                    </Row>
                    <Row className="referrals-moments" marginTop="4">
                        <MomentsGrid
                            showEntries={9}
                            nextTitle="Next goals"
                            loading={loadingClips}
                            clips={clips}
                            utmCampaign={"main"}
                            utmSource={"trace"}
                            utmMedium={"goal"}
                        />
                    </Row>
                    <Button
                        className="how-it-works-button"
                        marginTop="12"
                        height={56}
                        href="https://traceup.com/soccer/how-it-works"
                        target="_blank"
                        primary
                        small
                        content="See how Trace works"
                        trkAction="How Trace Works"
                    />
                </Column>
            </Element>
        </>
    )
}
